import React from 'react';
import { useDispatch } from 'react-redux';
import { Button, Typography } from '@mui/material';

import { useModel, useSettings, useUserData, Utils } from 'app/main/components';
import { DetailsSectionWrapper } from 'app/main/components/page-layouts';
import { type WbsRootNode } from './useWbsState';
import WbsModelsSaveDialog from './WbsModelsSaveDialog';
import WbsModelsLoadDialog from './WbsModelsLoadDialog';

interface WbsGraphMenuProps {
	root: WbsRootNode;
	nodes: any[];
	updateRefresh: VoidFunction;
}

export default function WbsGraphMenu({ root, nodes, updateRefresh }: WbsGraphMenuProps) {
	const dispatch = useDispatch();
	const { settings, t } = useSettings(root.table);
	const userData = useUserData();

	const [openModelSaveDialog, setOpenModelSaveDialog] = React.useState(false);
	const [openModelLoadDialog, setOpenModelLoadDialog] = React.useState(false);

	const { save } = useModel({
		baseModel: {
			[`${settings.modu_short}_uid`]: root.tableId,
			[`${settings.modu_short}_wbs_editable`]: 0
		},
		settings,
		isEdit: true
	});

	function generateActivities() {
		Utils.executeStored({
			action: 'st_wbs_nodes_generate_activities',
			params: {
				wbsn_table: root.table,
				wbsn_table_uid: root.tableId,
				wbsn_user_created_uid: userData.user_uid
			},
			dispatch,
			successHandler: response => {
				save({
					onSuccess: () => {
						dispatch(Utils.alertSuccessMsg(t));
						updateRefresh();
					}
				});
			}
		});
	}

	return (
		<>
			<DetailsSectionWrapper
				title={t('WBS_TITLE')}
				subheader={<Typography className="italic">{t('WBS_HELPTEXT')}</Typography>}
				actions={
					<>
						<Button onClick={() => setOpenModelSaveDialog(true)}>
							{t('WBS_DIALOG_ACTION_SAVE_MODEL')}
						</Button>
						<Button onClick={() => setOpenModelLoadDialog(true)} disabled={!root.isEditable}>
							{t('WBS_DIALOG_ACTION_LOAD_MODEL')}
						</Button>
						<Button onClick={generateActivities} disabled={!root.isEditable}>
							{t('WBS_DIALOG_ACTION_GENERATE_ACTIVITIES')}
						</Button>
					</>
				}
			>
				<Typography className="font-500 italic">{t('WBS_HELPTEXT_WARNING')}</Typography>
			</DetailsSectionWrapper>
			<WbsModelsSaveDialog open={openModelSaveDialog} onClose={() => setOpenModelSaveDialog(false)} root={root} />
			<WbsModelsLoadDialog
				open={openModelLoadDialog}
				onClose={() => setOpenModelLoadDialog(false)}
				root={root}
				updateRefresh={updateRefresh}
			/>
		</>
	);
}
